import {
  COMPONENT_VALUE_TYPES as types, PERCENTAGES, COMPONENT_COLOR_THEMES,
  BACKGROUND_IMAGE_POSITION, TWO_ROW_TEXT_LAYOUTS
} from 'shared/constants';

const propsSchema = [
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'dark_overlay',
        label: 'Dark Overlay',
        type: types.ENUM,
        options: PERCENTAGES
      },
      {
        key: 'position',
        label: 'Background Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      },
      {
        key: 'background_color',
        label: 'Background Color (if no image url is provided)',
        type: types.COLOR_PICKER
      }
    ]
  },
  {
    key: 'text_placement',
    label: 'Text Block Placement',
    type: types.ENUM,
    options: TWO_ROW_TEXT_LAYOUTS
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'description',
    label: 'Description',
    type: types.TEXTAREA
  },
  {
    key: 'feature',
    label: 'Feature',
    type: types.OBJECT,
    children: [
      {
        key: 'video_url',
        label: 'Video Url',
        type: types.TEXT
      },
      {
        key: 'video_cover',
        label: 'Video Cover',
        type: types.TEXT
      },
      {
        key: 'image_url',
        label: 'Image Url',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  color_theme: 'DARK',
  bg_img: {
    url: 'https://genesis-cdn.ff.com/product/05_technology/02.jpg',
    position: 'CENTER CENTER',
    dark_overlay: 0,
    background_color: ''
  },
  text_placement: 'BOTTOM',
  title: 'More personal with each drive',
  description: 'Your unique FFID profile encompasses an extensive range of your drive preferences and content choices. It’s how FF 91 recognizes and greets you before you enter the vehicle. And gets more intuitive about you every time you drive. Because the more you use FF 91, the smarter about you it becomes, delivering a truly bespoke experience.',
  feature: {
    video_url: 'https://genesis-cdn.ff.com/product/05_technology/03_1.mp4',
    video_cover: 'https://genesis-cdn.ff.com/product/05_technology/vidPoster.jpg',
    image_url: ''
  }
};

export default {
  title: 'Showcase',
  id: 'Showcase',
  propsSchema,
  defaultProps
};
